var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarRecommender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.55,
    height: 13.541,
    viewBox: "0 0 13.55 13.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "head-side-thinking",
    d: "M7.366,6.243A1.131,1.131,0,1,1,6.236,5.112,1.131,1.131,0,0,1,7.366,6.243Zm6.22,1.131A1.108,1.108,0,0,1,12.455,8.5h-.187l-.124.936a2.835,2.835,0,0,1-2.8,2.457H9.063a1.7,1.7,0,0,1-1.7,1.7H3.408a1.7,1.7,0,0,1-1.7-1.7v-.549a2.2,2.2,0,0,0-.418-1.332,6.216,6.216,0,1,1,9.918-7.5C11.928,3.407,13.586,6.571,13.586,7.374ZM8.407,5.648l.561-.323A.566.566,0,0,0,8.4,4.344l-.555.319a2.258,2.258,0,0,0-1.047-.6V3.416a.565.565,0,1,0-1.131,0v.646a2.258,2.258,0,0,0-1.049.6l-.555-.319a.566.566,0,0,0-.565.981l.561.323a2.035,2.035,0,0,0,0,1.191L3.5,7.161a.566.566,0,0,0,.565.981l.555-.319a2.258,2.258,0,0,0,1.047.6V9.07a.565.565,0,1,0,1.131,0V8.425a2.258,2.258,0,0,0,1.049-.6l.555.319a.566.566,0,0,0,.565-.981l-.561-.323a2.035,2.035,0,0,0,0-1.191Z",
    transform: "translate(-0.036 -0.053)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarRecommender);
export default __webpack_public_path__ + "static/media/sidebar-recommender.42b9ab222ac73f17bf0f0a9ee4bac30e.svg";
export { ForwardRef as ReactComponent };